import React from "react";

import style from "./DateRange.scss";

export default function DateRange(props)
{
    const isSameDay = props.start.isSame(props.end, 'day');

    return <div className={style.dateRange}>
        <div className={style.date}>
            <div className={style.month}>{props.start.format('MMM')}</div>
            <div className={style.day}>{props.start.format('DD')}</div>
            <div className={style.year}>{props.start.format('YYYY')}</div>
        </div>
        {isSameDay ? null :
            <>
                <div className={style.arrow}>&rarr;</div>
                <div className={style.date}>
                    <div className={style.month}>{props.end.format('MMM')}</div>
                    <div className={style.day}>{props.end.format('DD')}</div>
                    <div className={style.year}>{props.start.format('YYYY')}</div>
                </div>
            </>
        }
    </div>
}
